import { ImageLoaderProps } from 'next/image';

export const imageLoader = ({ src, width, quality }: ImageLoaderProps) =>
  `${process.env.NEXT_PUBLIC_CDN_URL || ''}${src}?w=${width}&q=${quality || 75}`;
